const TWINKL_BASE_LINK = "https://twinkl.co.uk" as const;
const TWINKL_PATH = (path: string) => `${TWINKL_BASE_LINK}${path}` as const;
const TWINKL_ACCOUNT = `${TWINKL_BASE_LINK}/my-account` as const;
const TWINKL_LOGIN_PAGE = `${TWINKL_BASE_LINK}/sign-in` as const;
const TWINKL_UPGRADE_PAGE = `${TWINKL_BASE_LINK}/premium/choose` as const;

export const links = {
  TWINKL_BASE_LINK,
  TWINKL_PATH,
  TWINKL_ACCOUNT,
  TWINKL_LOGIN_PAGE,
  TWINKL_UPGRADE_PAGE,
} as const;
